// Types
import { ESearchResultType } from '~/misc/location/search/types';

const INCLUDE_SEARCH: ESearchResultType[] = [
  ESearchResultType.POSTCODE,
  ESearchResultType.SECTOR,
  ESearchResultType.DISTRICT,
];

const SEARCH_MIN_CHARS: number = 2;

export { INCLUDE_SEARCH, SEARCH_MIN_CHARS };
